import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/levy/cdf';
import __var_2__ from '@stdlib/stats/base/dists/levy/ctor';
import __var_3__ from '@stdlib/stats/base/dists/levy/entropy';
import __var_4__ from '@stdlib/stats/base/dists/levy/logcdf';
import __var_5__ from '@stdlib/stats/base/dists/levy/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/levy/mean';
import __var_7__ from '@stdlib/stats/base/dists/levy/median';
import __var_8__ from '@stdlib/stats/base/dists/levy/mode';
import __var_9__ from '@stdlib/stats/base/dists/levy/pdf';
import __var_10__ from '@stdlib/stats/base/dists/levy/quantile';
import __var_11__ from '@stdlib/stats/base/dists/levy/stdev';
import __var_12__ from '@stdlib/stats/base/dists/levy/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace levy
*/
var levy = {};

/**
* @name cdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/cdf}
*/
setReadOnly( levy, 'cdf', __var_1__);

/**
* @name Levy
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/ctor}
*/
setReadOnly( levy, 'Levy', __var_2__);

/**
* @name entropy
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/entropy}
*/
setReadOnly( levy, 'entropy', __var_3__);

/**
* @name logcdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/logcdf}
*/
setReadOnly( levy, 'logcdf', __var_4__);

/**
* @name logpdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/logpdf}
*/
setReadOnly( levy, 'logpdf', __var_5__);

/**
* @name mean
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/mean}
*/
setReadOnly( levy, 'mean', __var_6__);

/**
* @name median
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/median}
*/
setReadOnly( levy, 'median', __var_7__);

/**
* @name mode
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/mode}
*/
setReadOnly( levy, 'mode', __var_8__);

/**
* @name pdf
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/pdf}
*/
setReadOnly( levy, 'pdf', __var_9__);

/**
* @name quantile
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/quantile}
*/
setReadOnly( levy, 'quantile', __var_10__);

/**
* @name stdev
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/stdev}
*/
setReadOnly( levy, 'stdev', __var_11__);

/**
* @name variance
* @memberof levy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/levy/variance}
*/
setReadOnly( levy, 'variance', __var_12__);


// EXPORTS //
export default levy;

export { __var_1__ as cdf, __var_2__ as Levy, __var_3__ as entropy, __var_4__ as logcdf, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as median, __var_8__ as mode, __var_9__ as pdf, __var_10__ as quantile, __var_11__ as stdev, __var_12__ as variance};